module.exports = __webpack_public_path__ + "img/sub-icon-white.e040d23b.svg";